import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './TrackingPage.css';
import Icon from '../../components/UI/Icon/Icon';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import * as actionTypes from '../../store/actions';
import carImg from '../../assets/images/car-icon.png';
import editImg from '../../assets/images/edit-icon.png';
import saveImg from '../../assets/images/save-icon.png';
import mapImg from '../../assets/images/map-icon.png';
import closeWhiteImg from '../../assets/images/close-white-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import openImg from '../../assets/images/open-white-icon.png';
import clockImg from '../../assets/images/clock-icon.png';
import copyImg from '../../assets/images/copy-white-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneMoreImg from '../../assets/images/phone-more-white-icon.png';
import homeGreenIcon from '../../assets/images/home-green-small-icon.png';
import storeIcon from '../../assets/images/store-small-icon.png';
import storeGreenIcon from '../../assets/images/store-small-green-icon.png';
import storeBlueIcon from '../../assets/images/store-small-blue-icon.png';
import warningImg from '../../assets/images/warning-white-icon.png';
import archiveImg from '../../assets/images/archive-icon.png';
import warningOrangeImg from '../../assets/images/warning-orange-icon.png';
import logError from '../../store/LogError';
import axios from '../../axios-trips';
import Button from '../../components/UI/Button/Button';
import ButtonIcon from '../../components/UI/ButtonIcon/ButtonIcon';
import ButtonIconConfirm from '../../components/UI/ButtonIconConfirm/ButtonIconConfirm';
import Confirm from '../../components/UI/ButtonIconConfirm/Confirm/Confirm';
import Loader from '../../components/Loader/Loader';
import ClientInfo from './ClientInfo/ClientInfo';
import Modal from '../../components/UI/Modal/Modal';
import Map from '../../components/Map/Map';

class Tracking extends Component {

  state = {
    editing: false,
    tripTrackingStatus: null,
    trip: null,
    showConfirm: false,
    confirm: null,
    confirmText: "",
    showClientInfo: false,
    clientInfo1: "",
    clientInfo2: "",
    clientName: "",
    mapLocations: [],
    mapPoints: [],
    mapOrigin: null,
    tracking: false,
    limitedTracking: false,
  }

  savePosition(position) {
    const query = new URLSearchParams(window.location.search);
    axios({
      method: 'get',
      url: '/api/v1/trip-tracking/tracking-unauth/tracking-location?trTk=' + query.get("trTk") + "&latitude=" + position.coords.latitude + "&longitude=" + position.coords.longitude +
      (query.get('transportCode') ?
        "&transportCode=" + query.get('transportCode') :
        "&trackingId=" + query.get('trackingId')),
    })
    .then(response => {
    })
    .catch(error => {
      console.log(error.response);
    });
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    if (query.get("token")) {
      let token = query.get("token");
      axios.get('/api/v1/authorize?token=' + token)
      .then(response => {
        console.log(response);
        if ((response.data === null || response.data === undefined) && localStorage.getItem("access_token") === null) {
          this.props.addNotification("Ссылка истекла. Пожалуйста, попробуйте еще раз.")
        } else {
          localStorage.setItem("access_token", response.data.access_token);
          localStorage.setItem("refresh_token", response.data.refresh_token);
          localStorage.setItem("name", localStorage.getItem("name"));
          this.props.onAuthenticated(response.data.access_token, response.data.refresh_token, null);
        }
        this.setState({ loading: false });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          if (error.response.status === 400) {
            this.props.addNotification("Данная ссылка истекла. Чтобы получить доступ к Kanban, сгенерируйте новую ссылку.", "Danger");
            this.props.history.push("/account");
          } else {
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        } else if (!error.response) {
          this.props.addNotification("Сервер не отвечает", "Danger");
        }
      });
    } else if ((query.get("transportCode") || query.get("trackingId")) && query.get("trTk")) {
      navigator.geolocation.getCurrentPosition(this.savePosition);

      axios({
        method: 'get',
        url:
        '/api/v1/trip-tracking/tracking-unauth/tracking-status?' +
        (query.get("transportCode") ? ('transportCode=' + query.get("transportCode")) : ("trackingId=" + query.get("trackingId"))) +
        "&trTk=" + query.get("trTk"),
        headers: { Authorization: "Bearer 1234" }
      })
      .then(response => {
        if (!response.data.tripTrackings || (response.data.tripTrackings && response.data.tripTrackings.length === 0)) {
          this.setState({ tripTrackingStatus: response.data });
          const tripTrackingStatus = response.data;
          axios({
            method: 'get',
            url:
            '/api/v1/trip-tracking/tracking-unauth/tracking?' +
            (query.get("transportCode") ? 'transportCode=' + query.get("transportCode") : '') +
            "&trTk=" + query.get("trTk") +
            (query.get("trackingId") ? "&trackingId=" + query.get("trackingId") : ''),
          })
          .then(response => {
            const updatedTripTrackingStatus = {...tripTrackingStatus};
            updatedTripTrackingStatus.tripTrackings = [...response.data];
            this.setState({ tripTrackingStatus: updatedTripTrackingStatus, editing: true });
          })
          .catch(error => {
            console.log(error.response);
            if (error.response) {
              this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
            } else if (!error.response) {
              this.props.addNotification("Сервер не отвечает.", "Danger");
            }
          });
        } else {
          const importTrackingStatus = response.data;
          importTrackingStatus.tripTrackings.sort((a, b) => a.sort - b.sort);
          this.setState({ tripTrackingStatus: importTrackingStatus, editing: true });
        }
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не отвечает.", "Danger");
        }
      });

      axios({
        method: 'get',
        url:
        '/api/v1/trip-tracking/tracking-unauth/trip?' +
        (query.get("transportCode") ? ('transportCode=' + query.get("transportCode")) : ("trackingId=" + query.get("trackingId"))) +
        "&trTk=" + query.get("trTk"),
      })
      .then(response => {
        this.setState({ trip: response.data });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не отвечает.", "Danger");
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.authenticated && this.props.authenticated && this.state.tripTrackingStatus === null) {
      const query = new URLSearchParams(window.location.search);
      if (query.get("tripId") && (query.get("transportCode") || query.get("trackingId"))) {
        let url = '/api/v1/trip-tracking/tracking-status?tripId=' + query.get("tripId") +
          '&transportCode=' + query.get("transportCode");
        if (query.get("trackingId")) {
          url = '/api/v1/trip-tracking/importing-status?trackingId=' + query.get("trackingId");
        }
        axios({
          method: 'get',
          url: url,
          headers: {'Authorization': 'Bearer ' + this.props.access_token},
        })
        .then(response => {
          this.setState({ tripTrackingStatus: response.data });

          if (!response.data.tripTrackings || (response.data.tripTrackings && response.data.tripTrackings.length === 0)) {
            axios({
              method: 'get',
              url: '/api/v1/manager-trackings?transportCode=' + response.data.transportCode,
              headers: {'Authorization': 'Bearer ' + this.props.access_token},
            })
            .then(response => {
              this.setState({ tracking: response.data });
            })
            .catch(error => {
              console.log(error.response);
              if (error.response) {
                logError(
                  this.props.access_token,
                  this.props.codeToMessage[error.response.status],
                  '/api/v1/manager-trackings' + "transportCode=" + query.get("transportCode")
                );
                this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
              } else if (!error.response) {
                this.props.addNotification("Сервер не отвечает.", "Danger");
              }
            });

            axios({
              method: 'get',
              url:
              '/api/v1/manager-limited-trackings?transportCode=' + response.data.transportCode,
              headers: {'Authorization': 'Bearer ' + this.props.access_token},
            })
            .then(response => {
              this.setState({ limitedTracking: response.data });
            })
            .catch(error => {
              console.log(error.response);
              if (error.response) {
                logError(
                  this.props.access_token,
                  this.props.codeToMessage[error.response.status],
                  '/api/v1/manager-limited-trackings' + "transportCode=" + query.get("transportCode")
                );
                this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
              } else if (!error.response) {
                this.props.addNotification("Сервер не отвечает.", "Danger");
              }
            });
          } else {
            axios({
              method: 'get',
              url: '/api/v1/manager-imports?trackingId=' + response.data.id,
              headers: {'Authorization': 'Bearer ' + this.props.access_token},
            })
            .then(response => {
              this.setState({ tracking: response.data });
            })
            .catch(error => {
              console.log(error.response);
              if (error.response) {
                logError(
                  this.props.access_token,
                  this.props.codeToMessage[error.response.status],
                  '/api/v1/manager-imports'
                );
                this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
              } else if (!error.response) {
                this.props.addNotification("Сервер не отвечает.", "Danger");
              }
            });

            axios({
              method: 'get',
              url:
              '/api/v1/manager-limited-imports?trackingId=' + response.data.id,
              headers: {'Authorization': 'Bearer ' + this.props.access_token},
            })
            .then(response => {
              this.setState({ limitedTracking: response.data });
            })
            .catch(error => {
              console.log(error.response);
              if (error.response) {
                logError(
                  this.props.access_token,
                  this.props.codeToMessage[error.response.status],
                  '/api/v1/manager-limited-imports'
                );
                this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
              } else if (!error.response) {
                this.props.addNotification("Сервер не отвечает.", "Danger");
              }
            });
          }

          if (!response.data.tripTrackings || (response.data.tripTrackings && response.data.tripTrackings.length === 0)) {
            axios({
              method: 'get',
              url: '/api/v1/trip-tracking/trackings?tracking=' + this.state.tripTrackingStatus.tripTrackingId,
              headers: {'Authorization': 'Bearer ' + this.props.access_token},
            })
            .then(response => {
              const updatedTripTrackingStatus = {...this.state.tripTrackingStatus};
              updatedTripTrackingStatus.tripTrackings = [...response.data];
              this.setState({ tripTrackingStatus: updatedTripTrackingStatus });
            })
            .catch(error => {
              console.log(error.response);
              if (error.response) {
                logError(
                  this.props.access_token,
                  this.props.codeToMessage[error.response.status],
                  '/api/v1/trip-tracking/trackings?tracking=' + this.state.tripTrackingStatus.tripTrackingId
                );
                this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
              } else if (!error.response) {
                this.props.addNotification("Сервер не отвечает.", "Danger");
              }
            });
          }
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/trip-tracking/tracking-status?' + "transportCode=" + query.get("transportCode") + "&tripId=" + query.get("tripId")
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Сервер не отвечает.", "Danger");
          }
        });

        axios({
          method: 'get',
          url: '/api/v1/trips/trip?id=' + query.get("tripId"),
          headers: {'Authorization': 'Bearer ' + this.props.access_token},
        })
        .then(response => {
          this.setState({ trip: response.data });
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/trips/trip?id=' + query.get("tripId")
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          } else if (!error.response) {
            this.props.addNotification("Сервер не отвечает.", "Danger");
          }
        });
      }
    }
  }

  formatDatePretty(date) {
    if (date === undefined || date === null) {
      return null;
    }
    return date.substring(11, 16) + " " + date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(2, 4);
  }

  formatTime(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(11, 16).replace(/[^0-9]/g, "");
  }

  formatDate(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(0, 10);
  }

  getTrackingLabel(status) {
    let trackingLabel = "В пути";
    if (status === 1) {
      trackingLabel = "Будет в течение часа";
    } else if (status === 2) {
      trackingLabel = "Разгружается";
    } else if (status === 3) {
      trackingLabel = "Выгружено";
    }
    return trackingLabel;
  }

  getImportTrackingLabel(status) {
    let trackingLabel = "В пути";
    if (status === 1) {
      trackingLabel = "Будет в течении часа";
    } else if (status === 2) {
      trackingLabel = "В процессе";
    } else if (status === 3) {
      trackingLabel = "Прошел";
    }
    return trackingLabel;
  }

  getImportHeaderTrackingLabel(status) {
    let trackingLabel = "";
    if (status === 1) {
      trackingLabel = "На загрузке";
    } else if (status === 2) {
      trackingLabel = "Вышел в рейс";
    }
    return trackingLabel;
  }

  getTodayDate() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate());
    let date = tomorrow.getFullYear() + "-";
    if (tomorrow.getMonth() < 10) {
      date += "0";
    }
    date += (tomorrow.getMonth() + 1) + "-";
    if (tomorrow.getDate() < 10) {
      date += "0"
    }
    date += tomorrow.getDate();
    return date;
  }

  findRouteById(routeId) {
    for (let i = 0; i < this.props.routes.length; i++) {
      if (this.props.routes[i].id === routeId) {
        return this.props.routes[i];
      }
    }
    return null;
  }

  getRouteName(route) {
    if (route.tripPoints) {
      let routeName = "";
      route.tripPoints.forEach((tripPoint, index) => {
        if (index < route.tripPoints.length - 1) {
          routeName += tripPoint.location.locationName + " --> ";
        } else {
          routeName += tripPoint.location.locationName;
        }
      });
      return routeName
    }
    return null;
  }

  getTripRoute() {
    let route = this.state.trip;
    if (route) {
      let routeName = (
        route.tripPoints.map((tripPoint, index) => {
          return (
            <Aux>
            {
              index < route.tripPoints.length - 1 ?
              <Aux>
                <p>{tripPoint.location.locationName}</p>
                <Icon iconSource={arrowImg} iconClass={classes.ArrowIcon} />
              </Aux>
              :
              <Aux>
                <p>{tripPoint.location.locationName}</p>
              </Aux>
            }
            </Aux>
          );
        })
      );
      return routeName;
    } else {
      return null;
    }
  }

  getId(id) {
    if (id < 10) {
      return "00" + id;
    } if (id < 100) {
      return "0" + id;
    }

    if (id.length == 3) {
      return id;
    } else {
      return id.toString().substring(id.toString().length - 3, id.toString().length);
    }
  }

  updateStatusHandler = (ev, status, index, confirmtext) => {
    ev.preventDefault();
    this.setState({
      showConfirm: true,
      confirm: (ev) => this.updateStatus(status, index),
      confirmText: confirmtext
    });
  }

  managerTrack = (ev) => {
    ev.preventDefault();
    axios({
      method: 'post',
      url: '/api/v1/manager-trackings?transportCode=' + this.state.tripTrackingStatus.transportCode,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      this.props.addNotification("Перевозка успешно добавлена в отслеживание.", "Success");
      this.setState({ tracking: true });
    })
    .catch(error => {
      console.log(error.response);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/manager-trackings'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      } else if (!error.response) {
        this.props.addNotification("Сервер не отвечает.", "Danger");
      }
    });
  }

  managerLimitedTrack = (ev) => {
    ev.preventDefault();
    axios({
      method: 'post',
      url: '/api/v1/manager-limited-trackings?transportCode=' + this.state.tripTrackingStatus.transportCode,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      this.props.addNotification("Спасибо, вы будете уведомлены о доставке перевозки.", "Success");
      this.setState({ limitedTracking: true });
    })
    .catch(error => {
      console.log(error.response);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/manager-trackings'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      } else if (!error.response) {
        this.props.addNotification("Сервер не отвечает.", "Danger");
      }
    });
  }

  updateStatus = (status, index) => {
    const updatedStatus = {...this.state.tripTrackingStatus};
    if (status > 1) {
      for (let i = 0; i < index; i++) {
        updatedStatus.tripTrackings[i].status = 3;
      }
    }

    for (let i = updatedStatus.tripTrackings.length - 1; i > index; i--) {
      if (updatedStatus.tripTrackings[i].status !== 1) {
        updatedStatus.tripTrackings[i].status = 0;
      }
    }
    updatedStatus.tripTrackings[index].status = status;
    this.setState({ tripTrackingStatus: updatedStatus });
    this.updateTripTrackingStatus(updatedStatus);
  }

  resetDateTime(ev, index) {
    ev.preventDefault();
    this.props.changeTime({target: { value: null }}, index);
    this.props.changeDate({target: { value: null }}, index);
  }

  updateTripTrackingStatus(updatedTripStatus) {
    if (updatedTripStatus.transportCode) {
      axios({
        method: 'post',
        url: '/api/v1/trip-tracking/tracking-unauth',
        data: updatedTripStatus
      })
      .then(response => {
        this.props.addNotification("Успешно обновлено.", "Success");
        this.setState({ tripTrackingStatus: response.data });
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
    } else {
      axios({
        method: 'post',
        url: '/api/v1/trip-tracking/import-unauth',
        data: updatedTripStatus
      })
      .then(response => {
        this.props.addNotification("Успешно обновлено.", "Success");
        this.setState({ tripTrackingStatus: response.data });
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
    }
  }

  showClientInfo(index) {
    this.setState({
      showClientInfo: true,
      clientInfo1: this.state.tripTrackingStatus.tripTrackings[index].delivery1,
      clientInfo2: this.state.tripTrackingStatus.tripTrackings[index].delivery2,
      clientName: this.state.tripTrackingStatus.tripTrackings[index].clients
    });
  }

  parsePhones() {
    if (this.state.clientInfo2 === null) {
      return [];
    }
    let phones = this.state.clientInfo2.replace(/[-|(| |)]/g, '');
    phones = phones.match(/\d+/g);
    if (phones === null) {
      return [];
    }

    let parsedPhones = [];
    for (let i = 0; i < phones.length; i++) {
      let phone = phones[i];
      if (phone.length > 10) {
        phone = phone.substring(phone.length - 10, phone.length);
      }

      if (phone.length === 10) {
        parsedPhones.push(phone);
      }
    }

    return parsedPhones;
  }

  transformPoint(point, name) {
    let parsedPoints = point.trim().split(",");
    return {
      lat: parseFloat(parsedPoints[0]),
      lng: parseFloat(parsedPoints[1]),
      title: name,
      infoWindow: false
    };
  }

  transformPoints(points) {
    let transformedPoints = [];
    for (let i = 0; i < points.length; i++) {
      if (points[i].to !== null && points[i].to !== undefined && points[i].to !== "") {
        let icon = storeIcon;
        let complete = false;
        let infoWindow = false;
        if (points[i].status === 3) {
          icon = storeGreenIcon;
          complete = true;
        } else if (i > 0 && points[i-1].status === 3) {
          icon = storeBlueIcon;
          infoWindow = true;
        }
        transformedPoints.push(
          {...this.transformPoint(points[i].to, points[i].clients),
            icon: icon,
            complete: complete,
            infoWindow: infoWindow
          });
      }
    }
    return transformedPoints;
  }

  openMap = (ev) => {
    ev.preventDefault();
    axios({
      method: 'get',
      url: (
        this.state.tripTrackingStatus.transportCode ?
        '/api/v1/trip-tracking/tracking-locations?transportCode=' + this.state.tripTrackingStatus.transportCode :
        '/api/v1/trip-tracking/import-locations?trackingId=' + this.state.tripTrackingStatus.id
      ),
      headers: {'Authorization': 'Bearer ' + this.props.access_token}
    })
    .then(response => {
      console.log(response.data);
      this.setState({
        showMap: true,
        mapLocations: response.data.map(
          (location, index) => (
            {
              ...location,
              infoWindow: index === response.data.length - 1
            }
          )
        ),
        mapPoints: this.transformPoints(this.state.tripTrackingStatus.tripTrackings),
        mapOrigin: this.state.tripTrackingStatus.tripTrackings[0].from ? {...this.transformPoint(
          this.state.tripTrackingStatus.tripTrackings[0].from,
          this.state.tripTrackingStatus.tripTrackings[0].clients
        ),
        icon: homeGreenIcon,
        infoWindow: false
      } : null
      });
    })
    .catch(error => {
      console.log(error);
      if (error.response) {
        logError(
          this.props.access_token,
          error.response,
          '/api/v1/trip-tracking/tracking-locations?transportCode=' + this.state.tripTrackingStatus.transportCode
        );
        this.props.addNotification("Ошибка", "Danger");
      }
    });
  }

  copy = (ev) => {
    ev.preventDefault();
    document.getElementById("driver-details").select();
    document.execCommand("copy");
    this.props.addNotification("Детали водителя скопированы успешно.", "Success");
  }

  render() {
    return (
      <Aux>
        <Confirm
          clicked={this.state.confirm}
          show={this.state.showConfirm}
          confirmText={this.state.confirmText}
          closeCard={() => this.setState({ showConfirm: false })} />
        <ClientInfo
          modalClosed={(ev) => this.setState({ showClientInfo: false })}
          show={this.state.showClientInfo} >
          <h3>{ this.state.clientName }</h3>
          <p>{ this.state.clientInfo1 ? this.state.clientInfo1 : "" }</p>
          <br />
          <p>{ this.state.clientInfo2 ? this.state.clientInfo2 : "" }</p>
          <br />
          <hr />
          <br />
          <p>Потенциальные Телефоны:</p>
          <ul>
            {
              this.parsePhones().length === 0 ?
              <p><em>Не нашел подходящих телефонов</em></p>
              :
              this.parsePhones().map( phone => {
                return (
                  <li>
                    <a href={"tel:" + phone}>{ phone }</a>
                  </li>
                )
              })
            }
          </ul>
          <Button
            clicked={(ev) => this.setState({ showClientInfo: false })}
            extraClass={classes.ButtonClientInfo}
            btnType='Success'>
          ЗАКРЫТЬ
          </Button>
        </ClientInfo>
        {
          this.state.editing ?
          null :
          <Modal
            modalClosed={(ev) => this.setState({ showMap: false })}
            show={this.state.showMap}
            style={{ width: "80%", left: "10%", top: "15%" }} >
            <Map
              googleMapURL={"https://maps.googleapis.com/maps/api/js?key=AIzaSyBv7FMapsW_Jj8UybXjAWhTcvC4MrOvKPs&v=3.exp&libraries=geometry,drawing,places"}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div className={classes.Map} />}
              mapElement={<div style={{ height: `100%` }} />}
              mapPoints={this.state.mapPoints}
              mapOrigin={this.state.mapOrigin}
              infoWindow={(index, state) => this.markerInfoWindow(index, state)}
              pointInfoWindow={(index, state) => this.pointInfoWindow(index, state)}
              markers={this.state.mapLocations}></Map>
            <Button
              clicked={(ev) => this.setState({ showMap: false })}
              extraClass={classes.ButtonClientInfo}
              btnType='Success'>
            ЗАКРЫТЬ
            </Button>
          </Modal>
        }
        <div className={classes.TrackingPage}>
          { this.state.tripTrackingStatus ?
            <div className={classes.Tracking} style={this.props.noRestrictions ? { width: "100%", maxWidth: "100%" } : null}>
                <div className={classes.TrackingHeader}>
                  <div className={classes.HeaderInfo}>
                    <p className={[classes.TrackingTitle, classes.Block].join(' ')}>
                      <Icon iconSource={carImg} iconClass={classes.HeaderIcon} />
                      <em>{this.state.tripTrackingStatus.car}</em>
                    </p>
                    {this.getTripRoute()}
                    <p className={[classes.TrackingTitle, classes.Block].join(' ')}>Рейс {this.state.tripTrackingStatus.trip ? "#" + this.getId(this.state.tripTrackingStatus.trip.id) : null } | <em>{this.state.tripTrackingStatus.transportCode}</em></p>
                  </div>

                  {
                    !this.state.editing &&
                    <Aux>
                      <ButtonIcon
                        btnType='Success'
                        clicked={this.openMap}
                        iconClass={classes.ButtonIcon}
                        iconSource={mapImg}
                        small
                        style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                        iconAlt=''></ButtonIcon>
                      <ButtonIcon
                        btnType='Success'
                        clicked={this.copy}
                        iconClass={classes.ButtonIcon}
                        iconSource={copyImg}
                        small
                        style={{
                          width: "auto",
                          display: "inline-block",
                          marginLeft: "5px"
                        }}
                        iconAlt=''></ButtonIcon>
                    </Aux>
                  }
                </div>

                <div className={classes.TrackingBody}>
                  {
                    !this.state.editing && this.state.tripTrackingStatus && this.state.tripTrackingStatus.driver &&
                    <Aux>
                      <input
                        id="driver-details"
                        value={
                          this.state.tripTrackingStatus.driver.phone ?

                          "Машина " + this.state.tripTrackingStatus.car +
                          ", водитель " + this.state.tripTrackingStatus.driver.name +
                          " (" + this.state.tripTrackingStatus.driver.phone + ")" :

                          "Машина " + this.state.tripTrackingStatus.car +
                          ", водитель " + this.state.tripTrackingStatus.driver.name
                        }
                        className={classes.CopyField}
                      />
                    </Aux>
                  }

                  { this.state.tripTrackingStatus.tripTrackings.map( (point, index) => {
                    let prevPoint = index > 0 ? this.state.tripTrackingStatus.tripTrackings[index - 1] : null;
                    return (
                      <div
                        className={classes.Point}
                        key={index}>
                        <div className={classes.PointProgress}>
                          {
                            index > 0 ?
                            <div className={[classes.Line, point.status >= 1 ? classes.LineActive : null, point.status >= 2 ? classes.LineComplete : null].join(' ')}>
                            </div>
                            : null
                          }

                          { this.state.editing && index > 0 ?
                            <div className={[classes.StatusHolder, classes.FadeIn].join(' ')}>
                            {
                              index === 1 && !this.state.tripTrackingStatus.transportCode &&
                              <Aux>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 0}
                                      type="checkbox"
                                      onChange={(ev) => this.updateStatusHandler(
                                        ev,
                                        ev.target.checked ? 1 : 0,
                                        0,
                                        ev.target.checked ? "сообщить 'На загрузке' в " + prevPoint.clients : "убрать 'На загрузке' в " + prevPoint.clients
                                      )}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                  <p className={classes.StatusText}>На загрузке</p>
                                </label>
                                <div className={[classes.Link, prevPoint.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 1}
                                      type="checkbox"
                                      onChange={(ev) => this.updateStatusHandler(
                                        ev,
                                        ev.target.checked ? 2 : 1,
                                        0,
                                        ev.target.checked ? "сообщить 'Вышел в рейс' в " + prevPoint.clients : "убрать 'Вышел в рейс' в " + prevPoint.clients
                                      )}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                <p className={classes.StatusText}>Вышел в рейс</p>
                                </label>
                              </Aux>
                            }
                            {
                              index > 1 && index <= 3 &&
                              <Aux>
                                {
                                  index === 1 &&
                                  <p className={classes.BorderBottom}>Отправлен: { this.formatDatePretty(prevPoint.forecast) }</p>
                                }

                                { !this.state.tripTrackingStatus.transportCode &&
                                  <Aux>
                                  <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                    <div className={classes.CheckboxHolder}>
                                      <input
                                        className={classes.Checkbox}
                                        checked={prevPoint.status > 0}
                                        type="checkbox"
                                        onChange={(ev) => this.updateStatusHandler(
                                          ev,
                                          ev.target.checked ? 1 : 0,
                                          index - 1,
                                          ev.target.checked ? "сообщить 'Будет в течении часа' в " + prevPoint.clients : "убрать 'Будет в течении часа' в " + prevPoint.clients)}>
                                      </input>
                                      <span className={classes.Checkmark}></span>
                                    </div>
                                    <p className={classes.StatusText}>Будет в течении часа</p>
                                  </label>
                                  <div className={[classes.Link, prevPoint.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                                  <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                    <div className={classes.CheckboxHolder}>
                                      <input
                                        className={classes.Checkbox}
                                        checked={prevPoint.status > 1}
                                        type="checkbox"
                                        onChange={(ev) => this.updateStatusHandler(
                                          ev,
                                          ev.target.checked ? 2 : 1,
                                          index - 1,
                                          ev.target.checked ? "сообщить 'В процессе' в " + prevPoint.clients : "убрать 'В процессе' в " + prevPoint.clients)}>
                                      </input>
                                      <span className={classes.Checkmark}></span>
                                    </div>
                                  <p className={classes.StatusText}>В процессе</p>
                                  </label>
                                  <div className={[classes.Link, prevPoint.status > 2 ? classes.LinkActive : null].join(' ')}></div>
                                  <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                    <div className={classes.CheckboxHolder}>
                                      <input
                                        className={classes.Checkbox}
                                        checked={prevPoint.status > 2}
                                        type="checkbox"
                                        onChange={(ev) => this.updateStatusHandler(
                                          ev,
                                          ev.target.checked ? 3 : 2,
                                          index - 1,
                                          ev.target.checked ? "сообщить 'Прошел' в " + prevPoint.clients : "убрать 'Прошел' в " + prevPoint.clients)}>
                                      </input>
                                      <span className={classes.Checkmark}></span>
                                    </div>
                                    <p className={classes.StatusText}>Прошел</p>
                                  </label>
                                </Aux>
                                }
                              </Aux>
                            }

                              { ((index > 1 && this.state.tripTrackingStatus.transportCode) || (index > 3 && !this.state.tripTrackingStatus.transportCode)) ?
                                <Aux>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 0}
                                      type="checkbox"
                                      onChange={(ev) => this.updateStatusHandler(
                                        ev,
                                        ev.target.checked ? 1 : 0,
                                        index - 1,
                                        ev.target.checked ? "сообщить 'Будет в течении часа' в " + prevPoint.clients : "убрать 'Будет в течении часа' в " + prevPoint.clients
                                      )}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                  <p className={classes.StatusText}>Будет в течение часа</p>
                                </label>
                                <div className={[classes.Link, prevPoint.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 1}
                                      type="checkbox"
                                      onChange={(ev) => this.updateStatusHandler(
                                        ev,
                                        ev.target.checked ? 2 : 1,
                                        index - 1,
                                        ev.target.checked ? "сообщить 'Разгружается' в " + prevPoint.clients : "убрать 'Разгружается' в " + prevPoint.clients
                                      )}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                  <p className={classes.StatusText}>Разгружается</p>
                                </label>
                                <div className={[classes.Link, prevPoint.status > 2 ? classes.LinkActive : null].join(' ')}></div>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 2}
                                      type="checkbox"
                                      onChange={(ev) => this.updateStatusHandler(
                                        ev,
                                        ev.target.checked ? 3 : 2,
                                        index - 1,
                                        ev.target.checked ? "сообщить 'Выгружено' в " + prevPoint.clients : "убрать 'Выгружено' в " + prevPoint.clients
                                      )}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                  <p className={classes.StatusText}>Выгружено</p>
                                </label>
                                </Aux>
                              : null }
                            </div>
                            :

                            index > 0 ?
                            <div className={classes.StatusHolder}>
                              {
                                index === 1 &&
                                this.state.tripTrackingStatus.transportCode &&
                                <p
                                  className={[classes.BorderBottom, classes.TextSmall].join(' ')}>
                                  Отправлен: { this.formatDatePretty(prevPoint.forecast) }
                                </p>
                              }
                              {
                                prevPoint.forecast && prevPoint.status === 0 ?
                                <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                                  <div>
                                    <Icon
                                     iconSource={clockImg}
                                     iconClass={classes.ClockIcon} />
                                     <p>{this.formatDatePretty(prevPoint.forecast)}</p>
                                  </div>
                                </label>
                                :
                                  index === 1 &&
                                  !this.state.tripTrackingStatus.transportCode &&
                                  prevPoint.status < 2 ?
                                  <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                                    <p><em>{ this.getImportHeaderTrackingLabel(prevPoint.status) }</em></p>
                                  </label>
                                :
                                  index <= 3 && !this.state.tripTrackingStatus.transportCode &&
                                  prevPoint.status < 3 &&
                                  this.state.tripTrackingStatus.tripTrackings[index - 2] &&
                                  this.state.tripTrackingStatus.tripTrackings[index - 2].status > 1 ?
                                  <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                                    <p><em>{ this.getImportTrackingLabel(prevPoint.status) }</em></p>
                                  </label>
                                  :
                                  prevPoint.status < 3 &&
                                  (this.state.tripTrackingStatus.transportCode || (!this.state.tripTrackingStatus.transportCode && index > 3)) &&
                                  this.state.tripTrackingStatus.tripTrackings[index - 2] &&
                                  this.state.tripTrackingStatus.tripTrackings[index - 2].status !== 0 &&
                                  <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                                    <p><em>{ this.getTrackingLabel(prevPoint.status) }</em></p>
                                  </label>
                               }
                               {
                                  point.crash ?
                                  <Aux>
                                    <div className={classes.BorderTop}>
                                      <Icon
                                       iconSource={point.status >= 3 ? warningOrangeImg : warningImg}
                                       iconClass={[classes.CrashIcon, point.status < 3 ? classes.Pulse : null].join(' ')} />
                                      <p>Авария:</p>
                                    </div>
                                    <p>{point.comment}</p>
                                  </Aux>
                                  : null
                               }
                            </div>
                            : null
                          }

                        </div>
                        <div>
                          {
                            (index > 0 && prevPoint.status === 3 && point.status < 3) ||
                            index === this.state.tripTrackingStatus.tripTrackings.length - 1 && prevPoint.status === 3 ?
                            <p className={[classes.Index, classes.IndexMain, point.status >= 3 ? classes.IndexActive : null].join(' ')}>{index + 1}</p> :
                            <p className={[classes.Index, point.status >= 2 ? classes.IndexActive : null].join(' ')}>{index + 1}</p>
                          }

                          <div
                            className={classes.Inline}
                            onClick={
                              (this.state.tripTrackingStatus.tripTrackings[index].delivery1 ||
                                this.state.tripTrackingStatus.tripTrackings[index].delivery2) ? (ev) => this.showClientInfo(index) : null}>
                            {
                              (index > 0 && prevPoint.status === 3 && point.status < 3) ||
                              index === this.state.tripTrackingStatus.tripTrackings.length - 1 && prevPoint.status === 3 ?
                              <p className={this.state.tripTrackingStatus.tripTrackings[index].delivery1 ||
                                            this.state.tripTrackingStatus.tripTrackings[index].delivery2 ?
                                            classes.ClientLink : classes.ClientLinkDull}>{point.clients}</p>
                              :
                              <p className={this.state.tripTrackingStatus.tripTrackings[index].delivery1 ||
                                            this.state.tripTrackingStatus.tripTrackings[index].delivery2 ?
                                            classes.ClientLinkFaded : classes.ClientLinkDullFaded}>{point.clients}</p>

                            }
                            { this.state.editing ? null : <p className={classes.Managers}>{point.managers}</p> }
                          </div>

                          { this.state.editing && index === this.state.tripTrackingStatus.tripTrackings.length - 1 ?
                            <div className={[classes.StatusHolder, classes.FadeIn].join(' ')}>
                              { index > 0 ?
                                <Aux>
                                  <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                    <div className={classes.CheckboxHolder}>
                                      <input
                                        className={classes.Checkbox}
                                        checked={point.status > 0}
                                        type="checkbox"
                                        onChange={(ev) => this.updateStatusHandler(
                                          ev,
                                          ev.target.checked ? 1 : 0,
                                          index,
                                          ev.target.checked ? "сообщить 'Будет в течении часа' в " + point.clients : "убрать 'Будет в течении часа' в " + point.clients
                                        )}>
                                      </input>
                                      <span className={classes.Checkmark}></span>
                                    </div>
                                    <p className={classes.StatusText}>Будет в течение часа</p>
                                  </label>
                                  <div className={[classes.Link, point.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                                  <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                    <div className={classes.CheckboxHolder}>
                                      <input
                                        className={classes.Checkbox}
                                        checked={point.status > 1}
                                        type="checkbox"
                                        onChange={(ev) => this.updateStatusHandler(
                                          ev,
                                          ev.target.checked ? 2 : 1,
                                          index,
                                          ev.target.checked ? "сообщить 'Разгружается' в " + point.clients : "убрать 'Разгружается' в " + point.clients
                                        )}>
                                      </input>
                                      <span className={classes.Checkmark}></span>
                                    </div>
                                    <p className={classes.StatusText}>Разгружается</p>
                                  </label>
                                  <div className={[classes.Link, point.status > 2 ? classes.LinkActive : null].join(' ')}></div>
                                  <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                    <div className={classes.CheckboxHolder}>
                                      <input
                                        className={classes.Checkbox}
                                        checked={point.status > 2}
                                        type="checkbox"
                                        onChange={(ev) => this.updateStatusHandler(
                                          ev,
                                          ev.target.checked ? 3 : 2,
                                          index,
                                          ev.target.checked ? "сообщить 'Выгружено' в " + point.clients : "убрать 'Выгружено' в " + point.clients
                                        )}>
                                      </input>
                                      <span className={classes.Checkmark}></span>
                                    </div>
                                    <p className={classes.StatusText}>Выгружено</p>
                                  </label>
                                  {
                                    this.state.tripTrackingStatus.lastChange ?
                                    <div
                                       style={{color: "#4f4f4f", fontSize: "14px"}}>
                                       <br />
                                       Последнее обновление:<br />{this.formatDatePretty(this.state.tripTrackingStatus.lastChange)}
                                       <br />
                                       (обновил: { this.state.tripTrackingStatus.lastChangeSource})
                                     </div>
                                    : null
                                  }
                                </Aux>
                              : null }
                            </div>
                            :

                            index === this.state.tripTrackingStatus.tripTrackings.length - 1 ?
                            <div className={classes.StatusHolder}>
                              { point.forecast && point.status === 0 ?
                                <label className={classes.StatusLabel}>
                                  <div>
                                    <Icon
                                     iconSource={clockImg}
                                     iconClass={classes.ClockIcon} />
                                     <p>{this.formatDatePretty(point.forecast)}</p>
                                  </div>
                                </label>
                                :
                                  point.status < 3 && prevPoint.status !== 0 ?
                                    !this.state.tripTrackingStatus.transportCode && index <= 3 ?
                                      <label className={classes.StatusLabel}>
                                        <p><em>{ this.getImportTrackingLabel(point.status) }</em></p>
                                      </label>
                                    :
                                      <label className={classes.StatusLabel}>
                                        <p><em>{ this.getTrackingLabel(point.status) }</em></p>
                                      </label>
                                  : null
                               }
                               {
                                 this.state.tripTrackingStatus.lastChange ?
                                 <div
                                    className={classes.BorderTop}
                                    style={{color: "#4f4f4f", fontSize: "14px"}}>
                                    Последнее обновление:<br />{this.formatDatePretty(this.state.tripTrackingStatus.lastChange)}
                                    <br />
                                    (обновил: { this.state.tripTrackingStatus.lastChangeSource})
                                  </div>
                                 : null
                               }
                            </div>
                            : null }
                        </div>
                      </div>
                    );
                  } ) }
                </div>

                {
                  !this.state.editing && this.props.managerName && this.props.authenticated &&
                  <Aux>
                    <Button
                      clicked={(ev) => this.managerTrack(ev)}
                      extraClass={classes.TrackButton}
                      disabled={this.state.tracking}
                      btnType={ this.state.tracking ? 'Grey' : 'Success'}>
                      { this.state.tracking ? "В ОТСЛЕЖКЕ" : "ОТСЛЕЖИВАТЬ"}
                    </Button>
                    <Button
                      clicked={(ev) => this.managerLimitedTrack(ev)}
                      extraClass={classes.TrackButton}
                      disabled={this.state.limitedTracking}
                      btnType={ this.state.limitedTracking ? 'Grey' : 'Success'}>
                      { this.state.limitedTracking ? "СООБЩИМ О ДОСТАВКЕ" : "СООБЩИТЬ О ДОСТАВКЕ"}
                    </Button>
                  </Aux>
                }

            </div>
          : <Loader />
          }
        </div>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    authenticated: state.authenticated,
    codeToMessage: state.codeToMessage,
    managerName: state.managerName
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType }),
    onAuthenticated: (tokenValue, refreshValue, name) => dispatch({ type: actionTypes.LOGIN,
                                                                     access_token: tokenValue,
                                                                     refresh_token: refreshValue,
                                                                     name: name })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tracking);



// WEBPACK FOOTER //
// ./src/containers/TrackingPage/TrackingPage.js